<template>
  <label :for="sid" class="checkbox" v-bind:class="{ 'state-disabled': disabled, 'state-error': model.$error }">
    <input type="checkbox" :checked="checked" :disabled="disabled" :id="sid" ref="input" value="true" @change="onInput($event)" @focus="onFocus($event)" @blur="onBlur($event)" />
    <i></i>
    &nbsp;
    <slot>{{ getTitle }}</slot>
    <w-error :model="model"></w-error>
  </label>
</template>

<script>
import modelMixin from '../../mixins/modelMixin';
import WError from './error.vue';

export default {
  // Nie używać title jako body komponentu
  props: ['uncheckvalue'],
  mixins: [modelMixin],
  components: { WError },
  data() {
    return {
      sid: 'chk' + Math.random() * 1000000
    };
  },
  computed: {
    unvalue() {
      if (this.uncheckvalue === undefined) {
        if (this.value === 'true') {
          return 'false';
        } else if (this.value === 'on') {
          return 'off';
        } else {
          return false;
        }
      } else {
        return this.uncheckvalue;
      }
    },
    checked() {
      // let vv = this.$model.$value;
      if (this.$options.hasFocus) {
        return this.$options.localValue;
      }
      switch (this.model.$schema.type) {
        case 'boolean':
          return this.model.$value === 'true';
        case 'array':
          return this.model.$value.indexOf(this.value) > -1;
        default:
          return this.model.$value === this.value;
      }
    }
  },
  mounted() {
    // console.log('checkbox value', JSON.stringify(this.value));
    // console.log('disabled: ', this.disabled);
  },
  methods: {
    onFocus(evt) {
      this.$options.hasFocus = true;
      this.$emit('focus');
    },
    onBlur(evt) {
      this.$options.hasFocus = false;
      this.$emit('blur');
    },
    onInput(evt) {
      this.$options.localValue = evt.target.checked;
      if (evt.target.checked) {
        switch (this.model.$schema.type) {
          case 'boolean':
            this.model.$value = 'true';
            break;
          case 'string':
            this.model.$value = this.value;
            break;
          case 'array':
            const pos = this.model.$value.indexOf(this.$props.value);
            if (pos === -1) {
              this.model.$addRow(this.$props.value);
            }
            break;
        }
      } else {
        switch (this.model.$schema.type) {
          case 'boolean':
            this.model.$value = 'false';
            break;
          case 'string':
            this.model.$value = this.unvalue;
            break;
          case 'array':
            const pos = this.model.$value.indexOf(this.$props.value);
            if (pos > -1) {
              this.model.$removeRow(pos);
            }
            break;
        }
      }
      this.$emit('input');
      this.fieldChanged();
    }
  }
};
</script>
